<app-standard-data-table
    (gridRequested)="gridRequested($event)"
    [source]="groups"
    [sorts]="[{ prop: 'name', dir: 'asc' }]"
    [columns]="columns$ | async"
    [noRecordsMessage]="'administration.groupAdministration.noRecordsMessage' | translation | async"
    [selectionType]="SelectionType.single"
    (rowSelected)="emitSelect($event)"
></app-standard-data-table>
